// @flow

import T from 'prop-types';
import * as React from 'react';

import type { Csrf } from 'common/types';

export type Props = Csrf;

export default class CSRFInputField extends React.Component<Props> {
  render() {
    const { token, param } = this.props;
    return <input type="hidden" name={param} value={token} />;
  }
}

CSRFInputField.propTypes = {
  token: T.string.isRequired,
  param: T.string.isRequired
};
